export default __webpack_public_path__ + "static/media/19.8744040a.png";